export default {
  en: {
    'select_player': 'select player',
    'training': 'training',
    'all': 'all',
  }
};
